import ApiRequest from '../axiosInstance/request';
import { endpoints } from '../endpoints';

export const MemberCreateMutation = async (body) => {
  try {
    const res = await ApiRequest.post(endpoints.Editor.create, body);

    return res;
  } catch (error) {
    return error;
  }
};